import controller from './double-opt-warning-dialog.controller';

export default {
  controller,
  template: require('./double-opt-warning-dialog.html')
};



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/warning/double-opt-warning-dialog.component.ts